import PicklistMetadata from "../PicklistMetadata";

class AccountUserEmailPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "AccountUserEmail";
        this.bounded = true;
        this.enterpriseComponent = "AccountUser";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.sortSpecification = null;
        this.static = false;
        this.typeField = null;
        this.typeValue = "Email";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.allowNoSelection = false;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = null;
    }
}

export default AccountUserEmailPicklistMetadata;
